import script from "./OverviewBonusCreditWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewBonusCreditWidget.vue?vue&type=script&setup=true&lang=js"

import "./OverviewBonusCreditWidget.vue?vue&type=style&index=0&id=d3eaaed8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3eaaed8"]])

export default __exports__